import { render, staticRenderFns } from "./EventPanel.vue?vue&type=template&id=c34184a6&scoped=true&"
import script from "./EventPanel.vue?vue&type=script&lang=ts&"
export * from "./EventPanel.vue?vue&type=script&lang=ts&"
import style0 from "./EventPanel.vue?vue&type=style&index=0&id=c34184a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34184a6",
  null
  
)

export default component.exports